import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { LoginComponent } from "./modules/login/login.component";
import { NotFoundComponent } from "./modules/shared/components/not-found/not-found.component";
import { RecoverPasswordComponent } from "./modules/login/recover-password/recover-password.component";
import { RegisterComponent } from "./modules/login/register/register.component";
import { LoggedGuard } from "./commons/guards/logged.guard";

const routes: Routes = [
  {
    path: "login",
    component: LoginComponent
  },
  {
    path: "recover",
    component: RecoverPasswordComponent
  },
  {
    path: "register",
    component: RegisterComponent
  },
  {
    path: "404",
    component: NotFoundComponent
  },
  {
    path: "",
    loadChildren: "./modules/master/master.module#MasterModule",
    canActivate: [LoggedGuard],
  },
  {
    path: "**",
    redirectTo: "/404"
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
